import { z } from 'zod';
import { id } from '../../common/atomic/id';
import { sex } from '../../common/atomic/sex';
import { addressSchema } from '../../common/basic/address';
import { date } from '../../common/atomic/date';
import { pageableSchema } from '../pageable/response';
import { careRequirementsSchema } from '../../common/basic/careRequirement';
import { dateTime } from '../../common/atomic/dateTime';
import { emergencyContactSchema } from '../../common/basic/emergencyContact';
import { keyEmpSchema } from '@/schemas/API/common/basic/keyEmployee';

const applicantSchema = z.object({
  id,
  serviceId: id,
  firstName: z.string(),
  lastName: z.string(),
  sex,
  servAddress: addressSchema,
  currState: z.string(),
  updatedAt: date,
});

const applicantsSchema = z
  .object({
    content: z.array(applicantSchema),
  })
  .merge(pageableSchema);

export const applicantDetailedSchema = z.object({
  id: z.number(),
  serviceId: z.number(),
  clientId: id.nullable(),
  keyEmp: keyEmpSchema,
  firstName: z
    .string()
    .min(2, { message: 'Jméno musí být dlouhé aspoň 2 znaky' }),
  lastName: z
    .string()
    .min(2, { message: 'Příjmení musí být dlouhé aspoň 2 znaky' }),
  title: z.string().nullable(),
  sex: z.string(),
  birthdate: date,
  statusDesc: z.string(),
  careReq: careRequirementsSchema,
  note: z.string().nullable(),
  prefTime: z.string().nullable(),
  servAddress: addressSchema,
  permAddress: addressSchema,
  commDate: date,
  createdAt: dateTime,
  updatedAt: dateTime,
  startDate: date.nullable(),
  cancelReasons: z.array(z.string()),
  currState: z.string(), // TODO add validation based on BE response
  contacts: z.array(emergencyContactSchema),
});

export type Applicant = z.infer<typeof applicantSchema>;
export type Applicants = z.infer<typeof applicantsSchema>;
export type ApplicantDetailed = z.infer<typeof applicantDetailedSchema>;
